module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/3.4be4bc4e.png";